import { useIntl } from 'react-intl';
import { TwilioError } from '@twilio/voice-sdk';

/**
 * Returns a humanized error message for Twilio errors, dealing with the most common cases.
 * See: https://www.twilio.com/docs/voice/sdks/error-codes
 */
export function useHumanizeTwilioError() {
    const { formatMessage } = useIntl();

    return (error: TwilioError.TwilioError): string => {
        switch (error.code) {
            case 31003:
                return formatMessage({
                    id: 'phoning.twilio.error.31003',
                });

            case 31005:
                return formatMessage({
                    id: 'phoning.twilio.error.31005',
                });

            case 31009:
                return formatMessage({
                    id: 'phoning.twilio.error.31009',
                });

            case 31202:
                return formatMessage({
                    id: 'phoning.twilio.error.31202',
                });

            case 31205:
                return formatMessage({
                    id: 'phoning.twilio.error.31205',
                });

            case 31206:
                return formatMessage({
                    id: 'phoning.twilio.error.31206',
                });

            case 31208:
                return formatMessage({
                    id: 'phoning.twilio.error.31208',
                });

            case 31401:
                return formatMessage({
                    id: 'phoning.allow-microphone',
                });

            case 53405:
                return formatMessage({
                    id: 'phoning.twilio.error.53405',
                });

            default:
                return formatMessage({
                    id: 'phoning.twilio.error.generic',
                });
        }
    };
}
